export const FETCH_PROJECT_BEGIN = "FETCH_PROJECT_BEGIN";
export const FETCH_PROJECT_SUCCESS = "FETCH_PROJECT_SUCCESS";
export const FETCH_PROJECT_FAILURE = "FETCH_PROJECT_FAILURE";
export const UPDATE_PROJECT_BEGIN = "UPDATE_PROJECT_BEGIN";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_FAILURE = "UPDATE_PROJECT_FAILURE";
export const OPEN_CREATE_REPORT_MODAL = "OPEN_CREATE_REPORT_MODAL";
export const CLOSE_CREATE_REPORT_MODAL = "CLOSE_CREATE_REPORT_MODAL";
export const START_EDIT = "START_EDIT";
export const END_EDIT = "END_EDIT";
